import ProductCarousel from './ProductCarousel';

export default ProductCarousel;
